import {InfoBlockGroup} from './components/info-block-group';
import {InfoBlockItem} from './components/info-block-item';
import {InfoBlockRoot} from './components/info-block-root';

export const InfoBlock = Object.assign(InfoBlockRoot, {
	Group: InfoBlockGroup,
	Item: InfoBlockItem,
});
